<template>
  <div class="warp">
    <div class="search">
      月份：
      <el-date-picker type="month" v-model="time" size="small" :clearable="false" class="w-150" placeholder="选择月"></el-date-picker>
      <el-button class="m-l-10" type="primary" size="small" @click="getData">查询</el-button>
    </div>
    <div class="table-content">
      <nk-table :data="tableData" :columns="columns" :showPage="false">
        <el-table-column slot="channel" label="支付方式" width="100" align="center">
          <template slot-scope="scope">
            {{payType[scope.row.channel]}}
          </template>
        </el-table-column>
        <el-table-column slot="status" label="支付状态" width="100" align="center">
          <template slot-scope="scope">
            {{status[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column slot="operation" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 1" type="text" @click="repaymentForBalanceTopUpOrder(scope.row)">重新支付</el-button>
          </template>
        </el-table-column>
      </nk-table>

      <PayDialog v-if="payVisible" :info="selectedRow" @close="bindClose"></PayDialog>
    </div>
  </div>
</template>

<script>
import api from '@common/api/index.js'
import NkTable from '@/components/common/NkTable.vue'
import dateTool from '@/utils/dateTool.js'
import PayDialog from '../PayDialog.vue'
import config from '@common/config/index.js'
export default {
  components: { NkTable, PayDialog },
  data () {
    return {
      payType: config.payType,
      status: { 1: '未支付', 2: '已支付', 3: '已取消', 4: '已超时' },
      tableData: [],
      time: new Date(),
      columns: [
        {
          prop: "id",
          label: "订单号",
          show: true,
        },
        {
          prop: "time",
          label: "订单时间",
          show: true,
        },
        {
          prop: "amount",
          label: "金额",
          show: true,
        },
        {
          prop: "channel",
          slot: "channel",
          label: "支付方式",
          show: true,
        },
        {
          prop: "status",
          slot: "status",
          label: "支付状态",
          show: true,
        },
        {
          prop: "statusModifyingTime",
          label: "状态改变时间",
          show: true,
        },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      payVisible: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let startTime = dateTool.format(this.time, 'yyyy/MM') + '/01 00:00:00'
      let nextMonth = new Date()
      nextMonth.setMonth(this.time.getMonth() + 1)
      let endTime = dateTool.format(nextMonth, 'yyyy/MM') + '/01 00:00:00'

      api.balance.getCompanyBalanceTopUpOrder(0, startTime, endTime).then(res => {
        if (res.data) {
          this.tableData = res.data
        }
        else {
          this.tableData = []
        }
      })
    },
    repaymentForBalanceTopUpOrder (obj) {
      this.selectedRow = obj
      api.balance.repaymentForBalanceTopUpOrder(obj.id).then(res => {
        if (res.data) {
          this.selectedRow.paymentCode = res.data.paymentCode
          this.payVisible = true
        }
      })
    },
    bindClose () {
      this.payVisible = false
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 0px 14px;
  box-sizing: border-box;
  color: #2e3842;
  text-align: left;
  display: flex;
  flex-flow: column;
  .search {
    flex: 0 0 40px;
  }
  .table-content {
    flex: 1;
    padding-bottom: 10px;
    box-sizing: border-box;
    overflow: hidden;
  }
}
.w-150 {
  width: 150px;
}
.m-l-10 {
  margin-left: 10px;
}
</style>